

import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../utils/api';

export const getSupplierForecastSearchTable = createApi(`SupplierForecastSearchTableSlice`,"POST");

const SupplierForecastSearchTableSlice = createSlice({
  name: 'SupplierForecastSearchTableSlice',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getSupplierForecastSearchTable.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getSupplierForecastSearchTable.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getSupplierForecastSearchTable.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default SupplierForecastSearchTableSlice.reducer;